import {
  FETCH_DEVICEEXPO,
  FETCH_DEVICEEXPO_SUCCESS,
  FETCH_DEVICEEXPO_FAILED,
  EDIT_DEVICEEXPO,
  EDIT_DEVICEEXPO_SUCCESS,
  EDIT_DEVICEEXPO_FAILED,
  ADD_DEVICEEXPO,
  ADD_DEVICEEXPO_SUCCESS,
  ADD_DEVICEEXPO_FAILED,
  DELETE_DEVICEEXPO,
  DELETE_DEVICEEXPO_SUCCESS,
  DELETE_DEVICEEXPO_FAILED,
} from "../store/types";


export const fetchDeviceExposure = () => (dispatch) => {
  dispatch({
    type: FETCH_DEVICEEXPO,
    payload: null,
  });

  try {
 const myHeaders = new Headers();
 myHeaders.append("Accept", "text/plain");

 const requestOptions = {
   method: "GET",
   headers: myHeaders,
   redirect: "follow",
 };
    // change url to deployed api url

    fetch("localhost:32784/api/device_exposure", requestOptions)
      .then((response) => {
        console.log("i am the response", response);
        dispatch({
          type: FETCH_DEVICEEXPO_SUCCESS,
          payload: response,
        });
      })
      .then((result) => console.log("this is created user results: ", result))
      .catch((error) => console.log("error", error));
  } catch (err) {
    dispatch({
      type: FETCH_DEVICEEXPO_FAILED,

      payload: err,
    });
    console.log("fail", err);
  }
};
export const addDeviceExposure = (deviceData) => (dispatch) => {
  dispatch({
    type: ADD_DEVICEEXPO,
    payload: null,
  });

  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "text/plain");

    const raw = deviceData;

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    // change url to deployed api url

    fetch("localhost:32784/api/device_exposure", requestOptions)
      .then((response) => {
        console.log("i am the response", response);
        dispatch({
          type: ADD_DEVICEEXPO_SUCCESS,
          payload: response,
        });
      })
      .then((result) => console.log("this is created user results: ", result))
      .catch((error) => console.log("error", error));
  } catch (err) {
    dispatch({
      type: ADD_DEVICEEXPO_FAILED,

      payload: err,
    });
    console.log("fail", err);
  }
};
export const editDeviceExposure = (id, deviceData) => (dispatch) => {
  dispatch({
    type: EDIT_DEVICEEXPO,
    payload: null,
  });

  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "text/plain");

    const raw = deviceData;

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    // change url to deployed api url

    fetch(`localhost:32784/api/device_exposure/${id}`, requestOptions)
      .then((response) => {
        console.log("i am the response", response);
        dispatch({
          type: EDIT_DEVICEEXPO_SUCCESS,
          payload: response,
        });
      })
      .then((result) => console.log("this is created user results: ", result))
      .catch((error) => console.log("error", error));
  } catch (err) {
    dispatch({
      type: EDIT_DEVICEEXPO_FAILED,

      payload: err,
    });
    console.log("fail", err);
  }
};

export const deleteDeviceExposure = (id) => (dispatch) => {
  dispatch({
    type: DELETE_DEVICEEXPO,
    payload: null,
  });

  try {
    const requestOptions = {
      method: "DELETE",
      redirect: "follow",
    };
    fetch(`localhost:32784/api/device_exposure/${id}`, requestOptions)
      .then((response) => {
        console.log("i am the response", response);
        dispatch({
          type: DELETE_DEVICEEXPO_SUCCESS,
          payload: response,
        });
      })
      .then((result) => console.log("this is created user results: ", result))
      .catch((error) => console.log("error", error));
  } catch (err) {
    dispatch({
      type: DELETE_DEVICEEXPO_FAILED,

      payload: err,
    });
    console.log("fail", err);
  }
};
